export const PurchaseOrderOrderTypeEnum = Object.freeze({
  STANDARD: "STANDARD",
  LAB: "LAB",
});
